<p>password-reset-failed works!</p>
